import { render, staticRenderFns } from "./OrdersLD.vue?vue&type=template&id=6d2170a1"
import script from "./OrdersLD.vue?vue&type=script&lang=js"
export * from "./OrdersLD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports